import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "revico-community-talk-user--reviewer-attribute-answer"
}
const _hoisted_2 = ["data-revico-reviewer-attribute-display-name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.reviewerAttributeAnswers.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.reviewerAttributeAnswers, (answer, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              "data-revico-reviewer-attribute-display-name": answer.displayName
            }, _toDisplayString(answer.displayName) + " : " + _toDisplayString(answer.choices.map((x) => x.displayName).join(",")), 9 /* TEXT, PROPS */, _hoisted_2))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]))
    : _createCommentVNode("v-if", true)
}